/* globals $ */
(function() {
  window.jui.dnd = {
    pixelThreshhold: 5,
    ghostIndex: 999999
  };

  var groups = {};
  var activeSource = null;
  var activeGroup = null;
  var activeGhost = null;
  var tracking = false;
  var dragging = false;
  var usePrototypeBinding = true;
  var startPageOffset;
  var startSourceOffset;
  var activeTarget = null;
  var shield = new Element('div', {className:'dnd-shield'});

  function mouseMoveListener(e) {
    var point = {
      left: Event.pointerX(e),
      top: Event.pointerY(e)
    };

    if (activeGhost) {
      positionGhost(point);
    }

    if (dragging) {
      testTargets(point);
    } else {
      var startOffset = e.startOffset || startPageOffset;
      if (Math.abs(startOffset.left - point.left) >= window.jui.dnd.pixelThreshhold ||
          Math.abs(startOffset.top - point.top) >= window.jui.dnd.pixelThreshhold) {
        startDragging(point);
      }
    }
  }

  window.jui.dnd.mouseMoveListener = mouseMoveListener;

  function cancelDragOrDrop(clearDrag) {
    tracking = false;
    removeGhost();
    removeShield();
    if (clearDrag) {
      // this is only used from element_pallet_dnd.js's dragCancel
      dragging = false;
    }
  }
  window.jui.dnd.cancelDragOrDrop = cancelDragOrDrop;

  function mouseUpListener(e) {
    cancelDragOrDrop();
    var point  = {left: Event.pointerX(e), top: Event.pointerY(e)};
    if (dragging) {
      stopDragging(point);
    }

    //TODO: remove when dnd updates complete
    if (usePrototypeBinding) {
      $(window.document).stopObserving( 'mouseup', mouseUpListener );
      $(window.document).stopObserving( 'mousemove', mouseMoveListener );
    }
  }

  window.jui.dnd.mouseUpListener = mouseUpListener;

  function initDragging(point) {
    if (activeSource.dragInit) {
      activeSource.dragInit(point);
    }

    if (activeGhost === null) {
      initGhost(point);
    }

    initShield();
  }

  function startDragging(point) {
    dragging = true;
    activeGroup.dragStart(point, activeSource);
    if (activeSource.dragStart) {
      activeSource.dragStart(point);
    }
    if (activeGhost === null) {
      initGhost(point);
    }
    initShield();
  }

  function stopDragging(point) {
    dragging = false;

    removeGhost();
    removeShield();

    if (activeTarget !== null && activeTarget.drop) {
      activeTarget.drop(point, activeSource);
      activeTarget = null;
    }

    if (activeSource && activeSource.dragStop) {
      activeSource.dragStop(point);
    }
  }

  function initGhost(point) {
    activeGhost = (typeof activeSource.getGhost === "function") ? activeSource.getGhost() : null;
    if (activeGhost) {
      document.body.insert(activeGhost);
      positionGhost(point);
    }
  }

  function initShield() {
    document.body.insert(shield);
  }

  function removeGhost() {
    if (activeGhost) {
      activeGhost.remove();
      activeGhost = null;
    }
  }

  function removeShield() {
    if (shield.parentNode === null) {
      return;
    }
    shield.remove();
  }

  function positionGhost(point) {
    if (activeSource.centerGhost) {
      activeGhost.style.left = (point.left - (Math.round(activeGhost.getWidth() / 2))) + 'px';
      activeGhost.style.top = (point.top - (Math.round(activeGhost.getHeight() / 2))) + 'px';
    } else {
      activeGhost.style.left = (point.left + startSourceOffset.left) + 'px';
      activeGhost.style.top = (point.top + startSourceOffset.top) + 'px';
    }
  }

  function targetFinder(point) {
    return new window.jui.dnd.TargetFinder(point, activeSource, activeGroup);
  }

  function _assignTarget(target, point) {
    var exitOldTarget =  function() {
      if (oldTarget.dragLeave) {
        oldTarget.dragLeave(point, activeSource);
      }
      if (activeSource.dragLeave) {
        activeSource.dragLeave(point, oldTarget);
      }
    };

    var enterNewTarget = function() {
      if (activeTarget.dragEnter) {
        activeTarget.dragEnter(point, activeSource);
      }
      if (activeSource.dragEnter) {
        activeSource.dragEnter(point, activeTarget);
      }
    };

    var oldTarget = activeTarget;
    activeTarget = target;
    if (oldTarget !== null) {
      exitOldTarget();
    }
    if (activeTarget !== null) {
      enterNewTarget();
    }
  }

  function _dragOverActiveTarget(point) {
    if (activeTarget.dragOver) {
      activeTarget.dragOver(point, activeSource);
    }
    if (activeSource.dragOver) {
      activeSource.dragOver(point, activeTarget);
    }
  }

  function testTargets(point) {
    var finder = targetFinder(point);
    var target = finder.target();

    if (target !== activeTarget) {
      _assignTarget(target, point);
    } else if (activeTarget !== null) {
      _dragOverActiveTarget(point);
    }
  }

  window.jui.dnd.manager = {
    getGroup: function(id) {
      return groups[id];
    },

    addGroup: function(id, g) {
      if (typeof groups[id] !== 'undefined') {
        throw "group with id "+id+" alread exists";
      }

      groups[id] = g;
      return g;
    },

    startTracking: function(source, e, options) {
      options = options || {};
      tracking = true;
      activeSource = source;
      activeGroup = source.getGroup();


      var x = Event.pointerX(e);
      var y = Event.pointerY(e);
      var sourceOffset = source.elm.cumulativeOffset();

      startPageOffset = {left: x, top: y};
      startSourceOffset = {left: sourceOffset.left - x, top: sourceOffset.top - y};

      var point = {
        left: Event.pointerX(e),
        top: Event.pointerY(e)
      };

      if (!options.threshhold) {
        initDragging(point);
      }

      //TODO: remove this and the bindings when completing other dnd
      usePrototypeBinding = options.hasOwnProperty('usePrototypeBinding') ? options.usePrototypeBinding : true;
      if(usePrototypeBinding) {
        $(window.document).observe( 'mouseup', mouseUpListener );
        $(window.document).observe( 'mousemove', mouseMoveListener );
      }

    },

    retestTargets: function(source, point) {
      if (activeSource !== source) {
        return;
      }

      activeTarget = null;
      testTargets(point);
    },

    leaveCurrentTarget: function(source, point) {
      if (activeSource !== source) {
        return;
      }

      var oldTarget = activeTarget;

      if (oldTarget !== null) {
        if (oldTarget.dragLeave) {
          oldTarget.dragLeave(point, activeSource);
        }
        if (activeSource.dragLeave) {
          activeSource.dragLeave(point, oldTarget);
        }
      }

      activeTarget = null;
    }
  };
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/jui/dnd/dnd.js
// module id = 315
// module chunks = 0 1